module.exports = __webpack_public_path__ + "img/gift.8fa7d32e.svg";